module.exports = __webpack_public_path__ + "static/media/hm10.d962330c.PNG";